import EditPrivacyPolicyModal from './EditPrivacyPolicyModal';

export default EditPrivacyPolicyModal;
